// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { z } from 'zod';
export const PaginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    page_size: z.coerce.number().int().min(1).max(100).default(25),
});
export const IdParamSchema = z.object({
    id: z.string().min(1, 'ID is required'),
});
export const EmailSchema = z.string().email('Valid email is required').max(254);
export const PhoneSchema = z.string().max(20).nullable().optional();
export const DateSchema = z
    .string()
    .datetime()
    .or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
export const UlidSchema = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/, 'Invalid ULID format');
export const UuidSchema = z.string().uuid('Invalid UUID format');
export const NameSchema = z.string().min(1, 'Name is required').max(200);
export const DescriptionSchema = z.string().max(10000).nullable().optional();
//# sourceMappingURL=common.js.map